import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import Button from "../../components/button/Button";
import { Fade } from "react-reveal";
import { works } from "../../portfolio";
import "./Works.css";

function openLiveUrl(url) {
  window.open(url, "_blank", "noopener,noreferrer");
}

class Works extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="works-main">
        <Header theme={theme} />
        <div className="basic-works">
          <Fade bottom duration={1000} distance="40px">
            <div className="works-heading-div">
              <h1 className="works-heading-text" style={{ color: theme.text }}>
                {works.title}
              </h1>
              <p
                className="works-heading-sub-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {works.subtitle}
              </p>
            </div>
          </Fade>
          <Fade bottom duration={2000} distance="40px">
            <div className="works-grid">
              {works.projects.map((project) => (
                <div
                  key={project.id}
                  className="work-card"
                  onClick={() => openLiveUrl(project.liveUrl)}
                >
                  <div
                    className="work-card-bar"
                    style={{ backgroundColor: project.color }}
                  />
                  <div className="work-card-body">
                    {project.logo && (
                      <div className="work-card-logo-div">
                        <img
                          className="work-card-logo"
                          src={project.logo}
                          alt={project.title}
                        />
                      </div>
                    )}
                    <h2
                      className="work-card-title"
                      style={{ color: theme.text }}
                    >
                      {project.title}
                    </h2>
                    <p className="work-card-description">
                      {project.description}
                    </p>
                    {/* stopPropagation: the Button renders its own <a>, so without
                        this the card's onClick would fire too and open twice */}
                    <div
                      className="work-card-btn"
                      onClick={(event) => event.stopPropagation()}
                    >
                      <Button
                        text="Visit Website →"
                        newTab={true}
                        href={project.liveUrl}
                        theme={theme}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Fade>
        </div>
        <Footer theme={theme} />
        <TopButton theme={theme} />
      </div>
    );
  }
}

export default Works;
